export default "__VITE_ASSET__51fe66fe__"